function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Shape",
  width: 24,
  height: 24,
  fill: "#021d3d",
  opacity: 0
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "list_edited",
  transform: "translate(4.001 6.801)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_81",
  d: "M11.594,12.976a1.242,1.242,0,0,1-.52-1.223l.232-1.386-.976-.961a1.233,1.233,0,0,1,.68-2.08l1.3-.191.584-1.241a1.2,1.2,0,0,1,2.176,0l.584,1.241,1.3.191a1.231,1.231,0,0,1,.68,2.08l-.96.976.232,1.385a1.24,1.24,0,0,1-.5,1.208,1.172,1.172,0,0,1-1.249.056L13.995,12.4l-1.136.649a1.167,1.167,0,0,1-1.264-.072ZM.249,9.4A.66.66,0,0,1,0,8.849.771.771,0,0,1,.75,8h6.4a.826.826,0,0,1,.6.249A.672.672,0,0,1,8,8.8a.708.708,0,0,1-.8.8H.8a.739.739,0,0,1-.112.008A.533.533,0,0,1,.249,9.4Zm0-4A.66.66,0,0,1,0,4.849.77.77,0,0,1,.75,4H10.2a.77.77,0,0,1,.75.85.849.849,0,0,1-.2.549.852.852,0,0,1-.549.2H.8a.849.849,0,0,1-.112.008A.531.531,0,0,1,.249,5.4Zm0-4A.66.66,0,0,1,0,.85.77.77,0,0,1,.75,0H15.2a.771.771,0,0,1,.551.249A.668.668,0,0,1,16,.8a.708.708,0,0,1-.8.8H.8a.849.849,0,0,1-.112.008A.533.533,0,0,1,.249,1.4Z",
  transform: "translate(0 0)"
}));

function SvgListStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "List_Star",
    "data-name": "List Star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListStart);
export default __webpack_public_path__ + "static/media/list_start.3ceeb305.svg";
export { ForwardRef as ReactComponent };